<template>
  	<div class="layout-tags">
		<ul ref="tags">
			<li v-for="tag in tagList" v-bind:key="tag" :class="isActive(tag)?'active':''" @contextmenu.prevent="openContextMenu($event, tag)">
				<router-link :to="tag">
					<span>{{ tag.title }}</span>
					<el-icon @click.prevent.stop='closeTags(tag)' v-if="!tag.hideClose"><el-icon-close/></el-icon>
				</router-link>
			</li>
		</ul>
	</div>
	<transition name="el-zoom-in-top">
		<ul v-if="contextMenuVisible" :style="{left:left+'px',top:top+'px'}" class="contextmenu" id="contextmenu">
			<li @click="refreshTag()"><el-icon><el-icon-refresh/></el-icon>刷新</li>
			<hr>
			<li @click="closeTags(contextMenuItem)" :class="contextMenuItem.hideClose?'disabled':''"><el-icon><el-icon-close/></el-icon>关闭标签</li>
			<li @click="closeOtherTags(contextMenuItem)"><el-icon><el-icon-folder-delete/></el-icon>关闭其他标签</li>
			<hr>
			<li @click="maximize()"><el-icon><el-icon-full-screen/></el-icon>{{isFullScreen?"最小化":"最大化"}}</li>
			<li @click="openWindow()"><el-icon><el-icon-copy-document/></el-icon>在新的窗口中打开</li>
		</ul>
	</transition>
</template>

<script>
import { useRouter, useRoute } from 'vue-router'

export default {
	data() {
		return {
			tagList:[],
			contextMenuVisible: false,
			contextMenuItem: [],
			top: 0,
			left: 0
		}
	},
	watch:{
		$route(e) {
			this.addTags(e);
		},
		contextMenuVisible(value) {	//单击关闭右键菜单
			const cm = (e) => {
				const sp = document.getElementById("contextmenu");
				if (sp && !sp.contains(e.target)) {
					this.closeMenu()
				}
			}
			if (value) {
				document.body.addEventListener('click', e => cm(e))
			} else {
				document.body.removeEventListener('click', e => cm(e))
			}
		}
	},
	methods:{
		openContextMenu(e, tag){	//打开右键菜单
			this.contextMenuItem = tag;
			this.contextMenuVisible = true;
			this.left = e.clientX + 1;
			this.top = e.clientY + 1;
			this.$nextTick(() => {
				let sp = document.getElementById("contextmenu");
				if(document.body.offsetWidth - e.clientX < sp.offsetWidth){
					this.left = document.body.offsetWidth - sp.offsetWidth + 1;
					this.top = e.clientY + 1;
				}
			})
		},
		closeMenu() {	//关闭右键菜单
			this.contextMenuItem = null;
			this.contextMenuVisible = false
		},
		isActive(route) {	//高亮当前标签
			return route.path === this.$route.path
		},
		addTags(route) {	//增加菜单标签
			if(this.tagList.findIndex((item) => item.path == route.path) > -1) return;
			this.tagList.push({name:route.name, path:route.path, title:route.meta.title, hideClose: route.meta.hideClose})
			this.$store.commit("pushKeepLive", route.name)
		},
		closeTags(route){	//关闭标签
			this.closeMenu()
			let index = this.tagList.findIndex((item) => item.path == route.path);
			this.tagList.splice(index, 1)
			this.$router.push(this.tagList[index-1].path)
			this.$store.commit("removeKeepLive", route.name)
		},
		refreshTag(){	//刷新页面
			this.contextMenuVisible = false
			const nowTag = this.contextMenuItem;
			this.$store.commit("setRouteShow", false)
			setTimeout(() => {
				this.$store.commit("removeKeepLive", nowTag.name)
				this.$store.commit("setRouteShow", true)
				this.$nextTick(() => {
					this.$store.commit("pushKeepLive", nowTag.name)
					this.$store.commit("setRouteShow", true)
				})
			}, 100);
		},
		closeOtherTags(route){
			this.closeMenu()
			let delList = []
			this.tagList.forEach((item) => {
				if(!item.hideClose && !(item.path == route.path)){
					delList.push(item);
				}
			})
			delList.forEach((item)=>{
				this.closeTags(item)
			})
		},
		maximize(){
			this.closeMenu()
			this.$store.commit('setFullScreen', !this.isFullScreen)
		},
		openWindow(){
			var nowTag = this.contextMenuItem;
			var url = nowTag.path || '/';
			window.open(url);
			this.contextMenuVisible = false
		}
	},
	computed:{
		isFullScreen(){
			return this.$store.state.app.isFullScreen;
		}
	},
	created(){
		this.tagList.push({name:'dashboard', path:'/dashboard', title:'控制台', hideClose: true })
		this.$store.commit("pushKeepLive", 'dashboard')
		this.addTags(useRoute());
	}
}
</script>

<style lang="scss" scoped>
.layout-tags {
	height:30px;
	background: #fff;
	border-bottom: 1px solid #e6e6e6;
	font-size: 12px;
	ul {
		display: flex;
		overflow: hidden;
	}
	li {
		cursor: pointer;
		display: inline-block;
		height:29px;
		line-height: 29px;
		position: relative;
		flex-shrink: 0;
	}
	li::after {
		content: " ";
		width:1px;
		height:100%;
		position: absolute;
		right:0px;
		background-image: linear-gradient(#fff, #e6e6e6);
	}
	li a {
		display: inline-block;
		padding:0 10px;
		width:100%;
		height:100%;
		color: #999;
		text-decoration:none;
		display: flex;
		align-items: center;
	}
	li i {
		margin-left:10px;
		border-radius: 3px;
		width:18px;
		height:18px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	li i:hover {
		background: rgba(0,0,0,.2);
		color: #fff;
	}
	li:hover {
		background: #ecf5ff;
	}
	li.active {
		background: #409EFF;
	}
	li.active a {
		color: #fff;
	}
	li.sortable-ghost {
		opacity: 0;
	}
}
.contextmenu {
	position: fixed;
	width: 200px;
	margin:0;
	border-radius: 0px;
	background: var(--el-bg-color-overlay);
	border: 1px solid var(--el-border-color-light);
	box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
	z-index: 3000;
	list-style-type: none;
	padding: 10px 0;
	font-size: 12px;
	hr {
		margin:5px 0;
		border: none;
		height: 1px;
		font-size: 0px;
		background-color: var(--el-border-color-light);
	}
	li {
		display: flex;
		align-items: center;
		margin:0;
		cursor: pointer;
		line-height: 30px;
		padding: 0 17px;
		color: #606266;
	}
	li i {
		font-size: 14px;
		margin-right: 10px;
	}
	li:hover {
		background-color: #ecf5ff;
		color: #66b1ff;
	}
	li.disabled {
		cursor: not-allowed;
		color: #bbb;
		background: transparent;
	}
}
</style>